/**
 * Polyfills Index
 */

import './svg4everybody/async-load__svg4everybody';
import 'babel-polyfill';
import './dom';

import numberIsInteger from './number-is-integer';
numberIsInteger();



// WEBPACK FOOTER //
// ./client/src/core/polyfills/index.js